import React, { FC, useEffect, useRef, useState } from 'react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file

import { DateRange } from 'react-date-range';
import moment from 'moment';
import classNames from 'classnames';
import FilterDeleteIcon from 'components/_common/icons/FilterDelete';

interface IDateRangeSelectorProps {
    dateRangeValue?: any;
    setDateRange?: any;
    clearDateRange?: any;
    onFilter?: any;
    showBelowInputBox?: boolean;
    calenderStyle?: string;
    inputWrapperStyle?: string;
    disabled?: boolean;
}

const DateRangeSelector: FC<IDateRangeSelectorProps> = (props) => {
    const {
        dateRangeValue,
        setDateRange,
        clearDateRange,
        onFilter,
        showBelowInputBox = true,
        disabled = false,
    } = props;
    const [dateRangeSelector, toggleDateRangeSelector] = useState(false);

    const [manualInputFromDate, setManualInputFromDate] = useState(
        (dateRangeValue?.startDate &&
            moment(dateRangeValue.startDate).format('DD-MM-yyyy')) ||
            ''
    );

    const [manualInputToDate, setManualInputToDate] = useState(
        (dateRangeValue?.endDate &&
            moment(dateRangeValue.endDate).format('DD-MM-yyyy')) ||
            ''
    );

    const onBlurInput = (e: { target: { value: any } }, dateType: string) => {
        // console.log('onBlur', e.target.value);
        if (e.target?.value) {
            let typedDate = moment(e.target.value, 'DD-MM-yyyy').toDate();

            // console.log(typedDate);
            // console.log(moment(typedDate).isValid());
            if (typedDate && moment(typedDate).isValid()) {
                // console.log('typed date is valid');
                let tempState = {
                    ...dateRangeValue,
                };
                if (dateType === 'startDate') {
                    tempState.startDate = typedDate;
                }
                if (dateType === 'endDate') {
                    tempState.endDate = typedDate;
                }

                setDateRange(tempState);
            }
        }
    };

    const getDateRangeValue = () => {
        let result = '';
        if (dateRangeValue?.startDate) {
            result += moment(dateRangeValue.startDate).format('DD-MM-yyyy');
        }

        if (dateRangeValue?.endDate) {
            result +=
                ' to ' + moment(dateRangeValue.endDate).format('DD-MM-yyyy');
        }

        return result;
    };

    const getRangeColors = () => {
        return document.body.classList.contains('theme-dark')
            ? ['#0D2041']
            : ['#3d91ff'];
    };

    const wrapperRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, false);
        return () => {
            document.removeEventListener('click', handleClickOutside, false);
        };
    }, []);

    const handleClickOutside = (event: { target: any }) => {
        if (wrapperRef?.current && !wrapperRef.current.contains(event.target)) {
            toggleDateRangeSelector(false);
        }
    };

    return (
        <div style={{ position: 'relative' }} ref={wrapperRef}>
            <div
                className={classNames(
                    'ws-input w-full flex items-center bg-white',
                    props.inputWrapperStyle,
                    {
                        'cursor-not-allowed': disabled,
                        'cursor-pointer': !disabled,
                    }
                )}
                onClick={() => {
                    if (!disabled) {
                        toggleDateRangeSelector(!dateRangeSelector);
                    }
                }}
            >
                <input
                    autoComplete="off"
                    type="text"
                    className={classNames(
                        'h-full px-0 py-0 m-0 border-0 shadow-none w-30 ws-input bg-white',
                        {
                            'cursor-not-allowed': disabled,
                            'cursor-pointer': !disabled,
                        }
                    )}
                    title={
                        disabled
                            ? 'Please select a entry'
                            : 'Select a date range'
                    }
                    placeholder="Date Range"
                    disabled={disabled}
                    // onClick={() => toggleDateRangeSelector(!dateRangeSelector)}
                    value={getDateRangeValue()}
                />

                {dateRangeValue?.startDate && dateRangeValue?.endDate ? (
                    <span
                        className={classNames('', {
                            'opacity-40 cursor-not-allowed': disabled,
                            'cursor-pointer': !disabled,
                        })}
                        title={
                            disabled
                                ? 'Please select a entry'
                                : 'Select a date range'
                        }
                        onClick={() => {
                            if (!disabled) {
                                clearDateRange();
                                toggleDateRangeSelector(false);
                                setManualInputFromDate('');
                                setManualInputToDate('');
                            }
                        }}
                    >
                        <FilterDeleteIcon className="inline-block pl-1" pathColor={"#001A70"} />
                    </span>
                ) : (
                    <span
                        className={classNames(
                            'flex items-center justify-center',
                            {
                                'opacity-40 cursor-not-allowed': disabled,
                                'cursor-pointer': !disabled,
                            }
                        )}
                        title={
                            disabled
                                ? 'Please select a entry'
                                : 'Select a date range'
                        }
                    >
                        <span
                            className="text-md bp3-icon bp3-icon-chevron-down text-fontQuinary"
                        />
                    </span>
                )}
            </div>

            {dateRangeSelector && (
                <>
                    <div
                        id="wsDateRangePicker"
                        className={classNames(
                            'flex bg-white px-4 py-4 rounded-lg text-fontPrimary border border-gray-200',
                            props.calenderStyle,
                            {
                                'z-20': showBelowInputBox,
                            }
                        )}
                        style={{
                            position: showBelowInputBox
                                ? 'absolute'
                                : undefined,
                        }}
                    >
                        <DateRange
                            editableDateInputs={true}
                            onChange={(item: any) => {
                                // console.log('item > ', item);

                                setDateRange(item.range1);
                                if (item?.range1?.startDate) {
                                    setManualInputFromDate(
                                        moment(item.range1.startDate).format(
                                            'DD-MM-yyyy'
                                        )
                                    );
                                }
                                if (item?.range1?.endDate) {
                                    setManualInputToDate(
                                        moment(item.range1.endDate).format(
                                            'DD-MM-yyyy'
                                        )
                                    );
                                }
                            }}
                            moveRangeOnFirstSelection={false}
                            ranges={[dateRangeValue]}
                            rangeColors={getRangeColors()}
                            showDateDisplay={false}
                            className='bg-white'
                        />
                        <div className="px-4 py-4">
                            <div className="flex justify-end">
                                <button
                                    className="px-12 py-4 mb-8 text-white bg-blue-600 rounded-md "
                                    onClick={() => {
                                        // close the daterangepicker dialog
                                        toggleDateRangeSelector(false);
                                        // call the api with the current filter
                                        onFilter();
                                    }}
                                >
                                    Filter
                                </button>
                            </div>

                            <p className='text-fontSeptenary'>From</p>
                            <div className="flex items-center ws-input">
                                <input
                                    autoComplete="off"
                                    type="text"
                                    className="w-full h-full px-0 py-0 m-0 border-0 shadow-none ws-input"
                                    value={manualInputFromDate}
                                    onChange={(e) => {
                                        if (e.target?.value) {
                                            setManualInputFromDate(
                                                e.target.value
                                            );
                                        }
                                    }}
                                    onBlur={(e) => {
                                        onBlurInput(e, 'startDate');
                                    }}
                                />
                                <span className="text-blue-600 text-md bp3-icon bp3-icon-calendar"></span>
                            </div>

                            <p className='text-fontSeptenary'>To</p>
                            <div className="flex items-center ws-input">
                                <input
                                    autoComplete="off"
                                    type="text"
                                    value={manualInputToDate}
                                    className="w-full h-full px-0 py-0 m-0 border-0 shadow-none ws-input"
                                    onChange={(e) => {
                                        if (e.target?.value) {
                                            setManualInputToDate(
                                                e.target.value
                                            );
                                        }
                                    }}
                                    onBlur={(e) => {
                                        onBlurInput(e, 'endDate');
                                    }}
                                />
                                <span className="text-blue-600 text-md bp3-icon bp3-icon-calendar"></span>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default DateRangeSelector;
